export enum Network {
  Arbitrum = 'arbitrum',
  Optimism = 'optimism',
}
